/**
 * @generated SignedSource<<e8215b14e3e821a52628b129b1a27a5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublishedNodesTable_PublishedNodesFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PublishedNodesActionColumn_NodeFragment" | "TitleColumnPublishedNodes_PublishedNodesFragment">;
  readonly " $fragmentType": "PublishedNodesTable_PublishedNodesFragment";
};
export type PublishedNodesTable_PublishedNodesFragment$key = {
  readonly " $data"?: PublishedNodesTable_PublishedNodesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublishedNodesTable_PublishedNodesFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PublishedNodesTable_PublishedNodesFragment"
};

(node as any).hash = "6a5643fc783db83164cbeadf37450fde";

export default node;
